import { SeoHead } from "@/components/SeoHead"
import { MarketingLayout } from "@/components/marketing/MarketingLayout"
import { Section, Eyebrow } from "@/components/marketing/sections/Section"
import { SeoAuditForm } from "@/components/marketing/SeoAuditForm"

const DESCRIPTION =
  "Free instant local SEO audit — see in 60 seconds whether your website is helping or hurting you with security, mobile, speed, and Google checks."

const WHAT_WE_CHECK = [
  {
    title: "Security & hacks",
    line: "Broken SSL certificates, \"Not Secure\" warnings, and hidden spam injected by hackers — problems that quietly tank your Google ranking.",
  },
  {
    title: "Mobile & speed",
    line: "Whether your site works on the phones your customers actually search from, and how fast it responds when they do.",
  },
  {
    title: "Google fundamentals",
    line: "Titles, descriptions, headlines, structured data — the signals that decide whether you show up when locals search for what you do.",
  },
]

export default function SeoAudit() {
  return (
    <MarketingLayout>
      <SeoHead title="Free Local SEO Audit" description={DESCRIPTION} />

      {/* Hero + form */}
      <Section containerClassName="max-w-3xl">
        <Eyebrow>FullCast · Local SEO</Eyebrow>
        <h1 className="display-1 mt-4">Is your website quietly costing you customers?</h1>
        <p className="mt-5 text-lg text-ink-body">
          Most service businesses have no idea their site has a broken
          certificate, a hack, or a mobile problem — until the calls slow down.
          Run a free 60-second audit and get a straight answer.
        </p>

        <div className="mt-10 rounded-2xl border border-hairline bg-surface p-6 sm:p-8">
          <h2 className="display-2">Run your free audit</h2>
          <p className="mt-2 text-ink-muted">
            Enter your website and email — the report runs immediately, right here.
          </p>
          <div className="mt-6">
            <SeoAuditForm source="audit_page" />
          </div>
        </div>
      </Section>

      {/* What we check */}
      <Section className="bg-surface" containerClassName="max-w-4xl">
        <Eyebrow>What we check</Eyebrow>
        <h2 className="display-2 mt-4">Ten checks, graded A to F</h2>
        <div className="mt-8 grid gap-5 sm:grid-cols-3">
          {WHAT_WE_CHECK.map((item) => (
            <div key={item.title} className="rounded-xl border border-hairline bg-page p-6">
              <h3>{item.title}</h3>
              <p className="mt-2 text-ink-muted">{item.line}</p>
            </div>
          ))}
        </div>
        <p className="mt-8 text-ink-muted">
          The audit is genuinely free — no call required, no strings. If it
          finds something serious, you'll know exactly what it is, whether you
          fix it with us or with anyone else.
        </p>
      </Section>
    </MarketingLayout>
  )
}
